<template>
  <router-view v-if="luyou" />
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      luyou: true
    }
  },
  methods: {
    reload () {
      this.luyou = false
      this.$nextTick(function () {
        this.luyou = true
      })
    }
  }
}
</script>

<style lang="scss">

</style>
